import PropTypes from "prop-types";
import React from "react";
import LayoutSidebar from "./LayoutSidebar";
import { appendClassName } from "../view-helpers";

function Layout(_ref) {
  var className = _ref.className,
      children = _ref.children,
      header = _ref.header,
      bodyContent = _ref.bodyContent,
      bodyFooter = _ref.bodyFooter,
      bodyHeader = _ref.bodyHeader,
      sideContent = _ref.sideContent;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: appendClassName("sui-layout", className)
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: "sui-layout-header"
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: "sui-layout-header__inner"
    }, header)),
    /*#__PURE__*/
    React.createElement("div", {
      className: "sui-layout-body"
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: "sui-layout-body__inner"
    },
    /*#__PURE__*/
    React.createElement(LayoutSidebar, {
      className: "sui-layout-sidebar"
    }, sideContent),
    /*#__PURE__*/
    React.createElement("div", {
      className: "sui-layout-main"
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: "sui-layout-main-header"
    },
    /*#__PURE__*/
    React.createElement("div", {
      className: "sui-layout-main-header__inner"
    }, bodyHeader)),
    /*#__PURE__*/
    React.createElement("div", {
      className: "sui-layout-main-body"
    }, children || bodyContent),
    /*#__PURE__*/
    React.createElement("div", {
      className: "sui-layout-main-footer"
    }, bodyFooter)))))
  );
}

Layout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  header: PropTypes.node,
  bodyContent: PropTypes.node,
  bodyFooter: PropTypes.node,
  bodyHeader: PropTypes.node,
  sideContent: PropTypes.node
};
export default Layout;